import * as f from './_cmFTH';
import * as ht from './_ht';


export const load_50rLsAsync = async (pz?: {
  cdn?: ht.s,
}) => {
  let _cdn = f.vdd(false, false);
  if (pz?.cdn) _cdn += ` AND (${pz?.cdn})`;
  //hf.l(`_cv_51 33: ${_cdn}`);
  const _ls = await f.loadLsAsync({
    tgt: '_50rs',
    cdn: _cdn,
    fld: '_fst as key, _pfx as pfx, *',
  });
  return _ls;
};

export const load_50rc1100sLsAsync = async (pz?: { // 設定分類
  cdn?: ht.s,
}) => {
  let _cdn = f.vdd(false, false);
  if (pz?.cdn) _cdn += ` AND ${pz?.cdn}`;
  const _ls = await f.loadLsAsync({
    tgt: '_50rs',
    cdn: _cdn,
    fld: 'distinct _50rc1100s as key, _50rc1100s as pfx',
    tailz: {
      odr: '',
    },
  });
  return _ls;
};
